/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
var Sizes;
(function (Sizes) {
    Sizes["2XS"] = "2xs";
    Sizes["XS"] = "xs";
    Sizes["SM"] = "sm";
    Sizes["MD"] = "md";
    Sizes["LG"] = "lg";
    Sizes["XL"] = "xl";
    Sizes["2XL"] = "2xl";
    Sizes["3XL"] = "3xl";
    Sizes["4XL"] = "4xl";
    Sizes["5XL"] = "5xl";
    Sizes["6XL"] = "6xl";
    Sizes["7XL"] = "7xl";
    Sizes["8XL"] = "8xl";
    Sizes["9XL"] = "9xl";
    Sizes["10XL"] = "10xl";
    Sizes["11XL"] = "11xl";
})(Sizes || (Sizes = {}));
const SizesArr = [
    "2xs",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "3xl",
    "4xl",
    "5xl",
    "6xl",
    "7xl",
    "8xl",
    "9xl",
    "10xl",
    "11xl",
];
const SpacingArr = [
    "0",
    "1",
    "1x",
    "2x",
    "3x",
    "4x",
    "5x",
    "6x",
    "7x",
    "8x",
    "9x",
    "10x",
    "11x",
    "12x",
    "16x",
    "20x",
    "24x",
    "32x",
    "48x",
    "64x",
    "80x",
    "full",
];
const spaceTokenArr = SpacingArr.map((suffix) => `var(--dui-size-space-${suffix})`);
var Variants;
(function (Variants) {
    Variants["error"] = "error";
    Variants["inverted"] = "inverted";
    Variants["primary"] = "primary";
    Variants["secondary"] = "secondary";
    Variants["success"] = "success";
    Variants["warn"] = "warn";
    Variants["valid"] = "valid";
    Variants["invalid"] = "invalid";
    Variants["note"] = "note";
    Variants["animated"] = "animated";
    Variants["static"] = "static";
    Variants["outline"] = "outline";
    Variants["text"] = "text";
    Variants["light"] = "light";
    Variants["dark"] = "dark";
    Variants["black"] = "black";
    Variants["empty"] = "empty";
    Variants["line"] = "line";
    Variants["arrow"] = "arrow";
    Variants["regular"] = "regular";
    Variants["striped"] = "striped";
    Variants["actionBox"] = "actionBox";
    Variants["copy"] = "copy";
    Variants["intro"] = "intro";
    Variants["numbers"] = "numbers";
    Variants["tilesHalf"] = "tilesHalf";
    Variants["tilesFull"] = "tilesFull";
    Variants["tracking"] = "tracking";
    Variants["date"] = "date";
})(Variants || (Variants = {}));
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["button"] = "button";
    ButtonTypes["reset"] = "reset";
    ButtonTypes["submit"] = "submit";
})(ButtonTypes || (ButtonTypes = {}));
var Orientation;
(function (Orientation) {
    Orientation["top"] = "top";
    Orientation["bottom"] = "bottom";
    Orientation["left"] = "left";
    Orientation["right"] = "right";
    Orientation["horizontal"] = "horizontal";
    Orientation["vertical"] = "vertical";
    Orientation["center"] = "center";
    Orientation["middle"] = "middle";
})(Orientation || (Orientation = {}));
var Steps;
(function (Steps) {
    Steps["current"] = "current";
    Steps["finished"] = "finished";
    Steps["partial"] = "partial";
    Steps["upcoming"] = "upcoming";
})(Steps || (Steps = {}));
var ColorVariants;
(function (ColorVariants) {
    ColorVariants["red"] = "red";
    ColorVariants["yellow"] = "yellow";
    ColorVariants["black"] = "black";
    ColorVariants["gray"] = "gray";
})(ColorVariants || (ColorVariants = {}));
const FlexDirectionArr = [
    "column",
    "row",
    "column-reverse",
    "row-reverse",
];

export { ButtonTypes as B, ColorVariants as C, FlexDirectionArr as F, Orientation as O, Sizes as S, Variants as V, SizesArr as a, SpacingArr as b, Steps as c, spaceTokenArr as s };

//# sourceMappingURL=constants-c94b83bd.js.map